<ng-container *ngIf="itemOption.bundle.length > 0">
  <eas-editor-booking-item-bundle-summary [bundle]="itemOption.bundle">
  </eas-editor-booking-item-bundle-summary>
  <br>
</ng-container>
<ng-container *ngFor="let itemSetting of itemOption.getSettingsWithSummary(); let itemSettingFirst = first; let itemSettingLast = last">
  <ng-container [ngSwitch]="itemSetting.settingClassName">
    <eas-editor-booking-item-setting-summary-booking-date *ngSwitchCase="'BookingDate'" [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
    </eas-editor-booking-item-setting-summary-booking-date>
    <eas-editor-booking-item-setting-summary-booking-window *ngSwitchCase="'BookingWindow'" [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
    </eas-editor-booking-item-setting-summary-booking-window>
    <eas-editor-booking-item-setting-summary-capacity *ngSwitchCase="'Capacity'" [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
    </eas-editor-booking-item-setting-summary-capacity>
    <eas-editor-booking-item-setting-summary-eligibility *ngSwitchCase="'Eligibility'" [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
    </eas-editor-booking-item-setting-summary-eligibility>
    <eas-editor-booking-item-setting-summary-pricing *ngSwitchCase="'Pricing'" [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
    </eas-editor-booking-item-setting-summary-pricing>
    <eas-editor-booking-item-setting-summary-venue *ngSwitchCase="'Venue'" [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
    </eas-editor-booking-item-setting-summary-venue>
    <eas-editor-booking-item-setting-summary-workflow *ngSwitchCase="'Workflow'" [itemSetting]="itemSetting" [first]="itemSettingFirst" [last]="itemSettingLast">
    </eas-editor-booking-item-setting-summary-workflow>
  </ng-container>
</ng-container>
